import React from 'react';
import axios from 'axios';
import { useState, useEffect } from 'react';
import "./Info.css";
const Info = () => {
    const [users, setUsers] = useState([]);
    /*const { name , mobile ,address} = user;*/
      const loadUsers = async () => {
        const data = await axios.get('http://localhost:3001/users');
      /* const data = await axios.get('https://my-json-server.typicode.com/RiyazSyed8790/mockjson/users');*/
        console.log(data.data)
        /*const data = await axios.get('https://github.com/RiyazSyed8790/mockjson/edit/main/db.json');*/
        setUsers(data.data);
        
        
      };
    useEffect(() => {
        loadUsers();
      }, []);
    
     return (
        <div className="info">
            <h3><br/></h3>
            <h4><br/></h4>
            <h4><br/></h4>
            <h1>Customers Information:</h1>
            <h4><br/></h4>
            <div className="content-container">
            <div className="user-cards">
        {users.map((user) => (
          <div className="user-card" key={user.id}>
            <h2>User Name: {user.name}</h2>
            <h3>Mobile: {user.mobile}</h3>
            <h3>Address: </h3>
            <p className="Address">{user.address}</p>
             </div>
        ))}
        </div>    
        </div>
        </div>
    )
}

export default Info
